export default __webpack_public_path__ + "designer-3d-shoe.jpeg";